import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './utils/pwaInstall';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enregistrer le service worker pour PWA
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[PWA] ✅ Service Worker enregistré avec succès !');
    console.log('[PWA] 📱 L\'application est maintenant installable');
  },
  onUpdate: (registration) => {
    console.log('[PWA] 🔄 Nouvelle version disponible');
    // La notification est gérée dans serviceWorkerRegistration.js
  }
});

// Vérifier si l'app est installée
if (window.matchMedia('(display-mode: standalone)').matches) {
  console.log('[PWA] 🎉 Application lancée en mode standalone (installée)');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
